import {
  ADD,
  REMOVE,
} from './mutation-types';

export default {
  [ADD](state, payload) {
    state.items = [...state.items, payload];
  },
  [REMOVE](state) {
    state.items = state.items = [];
  },
};
